import React, { useState, useEffect, useCallback } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import ImageTag from "../../../reusebale/imageTag";
import ButtonTag from "../../../reusebale/button";
import { Bed, Bath, Ruler } from "lucide-react";
import db from "../../../../db/index.json";
import PropertySuccessPopup from "../../../popup/propertySuccess";
import { Trash } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import MyLoader from "../../../reusebale/myLoader";
import * as PropertyAction from "../../../../store/actions/property/PropertyAction";
import { ShowError, ShowSuccess } from "../../../../utils/ToasFunction";
import UnitsCard from "../../../reusebale/uniCard";
import EditUnits from "../../../popup/editUnits";
import BaseUrl from "../../../../constants/BaseUrl";
const PropertyOverview = ({ onClose }) => {
  const dispatch = useDispatch();
  const {
    createNewPropertyBody,
    loader,
    createNewPropertySucc,
    createNewPropertyError,
    isUpdate,
    updatePropertySucc,
    updatePropertyError,
  } = useSelector((state) => state.property);
  const { loginSuccess } = useSelector((state) => state.auth);
  const { properties } = db;

  const [showSuccess, setShowSuccess] = useState(false);
  const [accountMapping, setAccountMapping] = useState(null);
  const [loadingAccount, setLoadingAccount] = useState(false);
  console.log(updatePropertySucc, "updatePropertySucc");

  const openPopup = () => {
    setShowSuccess(true);
  };

  const [showUnitPopUp, setShowUnitpopUp] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState({
    id: 0,
    unitName: "",
    totalBuilding: "",
    rent: "",
    rentType: "",
    offices: "",
    bathrooms: "",
    size: "",
    buildingDepth: "",
    clearHeight: "",
    parkingRation: "",
    sprinklers: "",
    water: "",
    electric: "",
    waltRollArea: "",
    numberOfSuites: "",
    lodingDocks: "",
    gradeLevelDoors: "",
    tenantSize: "",
    yearBuild: "",
    hvac: false,
    hvacValue: "",
  });

  const closePopup = () => {
    setShowSuccess(false);
    dispatch(PropertyAction.ClearAllPropertyCreateStatus());
    onClose();
  };

  const BackHandler = (e) => {
    e.preventDefault();
    dispatch(PropertyAction.ChangePropertyCreateSteps(3));
  };

  const fetchAccountMapping = useCallback(() => {
    if (!createNewPropertyBody?._id) return;

    setLoadingAccount(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/accountMapping/getByProperty/${createNewPropertyBody._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setLoadingAccount(false);
        if (result.status === "success" && result.data) {
          setAccountMapping(result.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching account mapping:", error);
        setLoadingAccount(false);
      });
  }, [loginSuccess?.token, createNewPropertyBody?._id]);

  useEffect(() => {
    if (createNewPropertySucc) {
      setShowSuccess(true);
      dispatch(PropertyAction.ClearAllPropertyCreateStatus());
    } else {
      ShowError(createNewPropertyError?.message);
    }
  }, [createNewPropertySucc, createNewPropertyError]);

  useEffect(() => {
    if (updatePropertySucc) {
      setShowSuccess(true);
      dispatch(PropertyAction.ClearAllPropertyCreateStatus());
    } else {
      ShowError(updatePropertyError?.message);
    }
  }, [updatePropertySucc, updatePropertyError]);

  useEffect(() => {
    // Fetch account mapping when component loads (for update flow)
    if (isUpdate && createNewPropertyBody?._id) {
      fetchAccountMapping();
    }
  }, [isUpdate, createNewPropertyBody?._id, fetchAccountMapping]);

  return (
    <div className="h-full">
      <div
        onClick={(e) => {
          e.preventDefault();
          console.log(JSON.stringify(createNewPropertyBody));
        }}
        className="text-center h-[8%]"
      >
        <ParagraphTag
          content="Property Overview"
          classes="text-darkColor font-popinsSemiBold text-base 2xl:text-lg"
        />
      </div>
      <div className="h-[82%] w-full overflow-y-scroll panelScroll">
        <div className="flex justify-center">
          <div className="w-[75%] py-5">
            <div className="flex justify-between py-2">
              <div className="w-[64%]">
                <div className="flex mt-3">
                  <div className="w-[50%] pr-1">
                    <ParagraphTag
                      content="Property Name"
                      classes={`text-darkColor font-popinsSemiBold text-sm `}
                    />
                    <ParagraphTag
                      content={createNewPropertyBody?.propertyName}
                      classes={`text-darkColor/50 font-popinsRegular text-xs pt-[2px]`}
                    />
                  </div>
                  <div className="w-[50%] pl-1">
                    <ParagraphTag
                      content="Property Type"
                      classes={`text-darkColor font-popinsSemiBold text-sm `}
                    />

                    <ParagraphTag
                      content={`${createNewPropertyBody?.category} ( ${createNewPropertyBody?.type} )`}
                      classes={`text-darkColor/50 font-popinsRegular text-xs pt-[2px]`}
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <ParagraphTag
                    content="Complete Address"
                    classes={`text-darkColor font-popinsSemiBold text-sm `}
                  />

                  <p className={`text-darkColor/50 font-popinsRegular text-xs pt-[2px] whitespace-pre-line`}>
                    {createNewPropertyBody?.completeAddress}
                  </p>
                </div>

              </div>
              <div className="w-[35%] h-[270px] mt-2">
                <ImageTag
                  classes="rounded-md w-full h-full object-cover"
                  path={createNewPropertyBody?.thumbnailImage?.url}
                  altText="logo"
                />
              </div>
            </div>
            {createNewPropertyBody?.sitePlan?.url && (
              <div className="mt-4">
                <ParagraphTag
                  content="Site Plan"
                  classes={`text-darkColor font-popinsSemiBold text-sm mb-2`}
                />
                <div className="w-[40%] h-[200px]">
                  <ImageTag
                    classes="rounded-lg w-full h-full object-cover"
                    path={createNewPropertyBody.sitePlan.url}
                    altText="Site Plan"
                  />
                </div>
              </div>
            )}
            {/* <div className="mt-2">
              <ImageTag
                classes="rounded-lg"
                path={"/assets/daashboard/map-overview.png"}
                altText="logo"
              />
            </div> */}
          </div>
        </div>

        <div className="bg-white py-5 rounded-xl">
          <div className="w-[95%] mx-auto pt-5 ">
            <div className="flex justify-between items-center">
              <ParagraphTag
                content="Bank Account"
                classes={`text-darkColor font-popinsSemiBold text-lg `}
              />
              {loadingAccount && (
                <ParagraphTag
                  content="Loading..."
                  classes={`text-gray-500 font-popinsRegular text-sm italic`}
                />
              )}
            </div>
            <div className="flex flex-wrap justify-between mt-3">
              {accountMapping && accountMapping.nickname ? (
                <div className="w-full">
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                    <div className="flex items-center gap-2">
                      <svg
                        className="w-5 h-5 text-green-600"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <ParagraphTag
                        content={
                          accountMapping.nickname.length >= 4
                            ? `${accountMapping.nickname.substring(0, 4)}****`
                            : accountMapping.nickname
                        }
                        classes={`text-green-700 font-popinsSemiBold text-md`}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-full">
                  <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                    <div className="flex items-center gap-2">
                      <svg
                        className="w-5 h-5 text-amber-600"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <ParagraphTag
                        content="Bank Account not setup"
                        classes={`text-amber-700 font-popinsSemiBold text-md`}
                      />
                    </div>
                    <ParagraphTag
                      content="A bank account will be created automatically when you save this property."
                      classes={`text-amber-600 font-popinsRegular text-sm mt-1 ml-7`}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="bg-white py-5 rounded-xl">
          <div className="w-[95%] mx-auto pt-5 ">
            <div className="flex justify-between">
              <ParagraphTag
                content="Units"
                classes={`text-darkColor font-popinsSemiBold text-lg `}
              />
            </div>
            <div className="flex flex-wrap justify-between mt-3">
              {createNewPropertyBody?.unitData?.map((item, i) => (
                <UnitsCard
                  isDeleteShow={true}
                  data={item}
                  classes="w-[49%] my-2 py-3 px-2 cursor-pointer "
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="h-[10%] flex justify-center items-center">
        {loader ? (
          <div className="flex justify-center items-center">
            <MyLoader />
          </div>
        ) : (
          <div className="w-[40%] mx-auto flex gap-4">
            <ButtonTag
              onSubmit={BackHandler}
              name="Back"
              classes="text-base bg-gray-500 text-center text-white"
            />
            <ButtonTag
              name={isUpdate ? "Update" : "Submit"}
              classes="text-base bg-themeColor text-center text-white"
              onSubmit={(e) => {
                e.preventDefault();
                if (!createNewPropertyBody.propertyName) {
                  ShowError("Property address information is missing");
                } else {
                  if (isUpdate) {
                    const finalArray = {
                      ...createNewPropertyBody,
                      unitCount: createNewPropertyBody.unitData.length,
                    };
                    dispatch(
                      PropertyAction.UpdatePropertyAction(
                        finalArray,
                        loginSuccess.token
                      )
                    );
                    // console.log(JSON.stringify(finalArray))
                  } else {
                    dispatch(
                      PropertyAction.CreateNewPropertyAction(
                        loginSuccess?.user?._id,
                        createNewPropertyBody,
                        loginSuccess.token
                      )
                    );
                  }
                }

                // loginSuccess
              }}
            />
          </div>
        )}
      </div>
      {showUnitPopUp && (
        <EditUnits
          selectedUnit={selectedUnit}
          onBack={() => {
            setShowUnitpopUp(false);
          }}
          unitNameValue={selectedUnit.unitName}
          buildingValue={selectedUnit?.totalBuilding}
          rentValue={selectedUnit?.rent}
          rentTypeValue={selectedUnit.rentType}
          officesValue={selectedUnit.offices}
          bathroomsValue={selectedUnit.bathrooms}
          sizeValue={selectedUnit.size}
          buildingDepthValue={selectedUnit.buildingDepth}
          clearHeightValue={selectedUnit.clearHeight}
          parkingRationValue={selectedUnit.parkingRation}
          sprinklersValue={selectedUnit.sprinklers}
          waterValue={selectedUnit.water}
          electricValue={selectedUnit.electric}
          waltRollAreaValue={selectedUnit.waltRollArea}
          noOfSuitsValue={selectedUnit.numberOfSuites}
          loadingDocksValue={selectedUnit.lodingDocks}
          gradeLevelDoorsValue={selectedUnit.gradeLevelDoors}
          yearBuildValue={selectedUnit.yearBuild}
          tenantsSizeValue={selectedUnit.tenantSize}
          hvacValue={selectedUnit.hvac}
          hvacNumberValue={selectedUnit.hvacValue}
        />
      )}
      {showSuccess && (
        <PropertySuccessPopup
          succMessage={`Property ${
            isUpdate ? "Updated" : "Created"
          } successfully`}
          onClose={closePopup}
        />
      )}
    </div>
  );
};

export default PropertyOverview;
